var exports = {
  "l": "scrollableUserList__WR0oc0",
};

module.exports = exports;
